import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorViewComponent } from './components/error-view/error-view.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { EulaGuard } from './guards/eulaCheck/eulaCheck.guard';
import { UserDataGuard } from './guards/userdata/userdata.guard';
import { HomeComponent } from './pages/home/home.component';
import { StudyDetailsComponent } from './pages/study-details/study-details.component';
import { StudyPortfolioComponent } from './pages/study-portfolio/study-portfolio.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard, UserDataGuard, EulaGuard],
    data: { breadcrumb: 'Home' }
  },
  {
    path: 'portfolio',
    component: StudyPortfolioComponent,
    canActivate: [AuthGuard, UserDataGuard, EulaGuard],
    data: { breadcrumb: 'My portfolio' }
  },
  {
    path: 'portfolio/study-details/:studySk',
    component: StudyDetailsComponent,
    canActivate: [AuthGuard, UserDataGuard, EulaGuard],
    data: { breadcrumb: 'My portfolio / Study {{protocolNumber}}' }
  },
  {
    path: '**',
    component: ErrorViewComponent,
    data: { type: 'not-found' },
    canActivate: [UserDataGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
